export const chartBackgroundColor = {
    Yellow:"#f7d209",
    Orange:"#ff9300",
    Red:"#ba0022",
    Pink:"#ba007c",
    Purple:"#9e00ba",
    Green:"#00ba8f",
    Blue:"#00BABA",
}